import { currentCopilotSession as e } from "../global-state.js";
import { CopilotSession as t } from "../session.js";
import { atom as n } from "nanostores";
import { useCallback as r, useEffect as i, useRef as a, useState as o } from "react";
import { useStore as s } from "@nanostores/react";
//#region src/react/session.ts
var c = n(void 0), l = n(null);
function u(n) {
	let s = a(n?.config);
	s.current = n?.config;
	let [c, l] = o(() => new t(s.current)), u = r(() => {
		let e = new t(s.current);
		return l(e), e;
	}, []);
	return i(() => {
		n?.isPrimary && e.set(c);
	}, [c, n?.isPrimary]), i(() => () => {
		c.dispose();
	}, [c]), Object.assign(c, { reset: u });
}
function d() {
	return s(e);
}
function f(e) {
	return s(e?.__id ?? c);
}
function p(e) {
	return s(e?.__status ?? l);
}
function m(e) {
	return s(e.__statefulMessages);
}
function h(e) {
	return s(e.__tools);
}
function g(e) {
	return s(e.__meta);
}
function _(e) {
	return s(e.__queuedMessages);
}
function v(e) {
	return s(e.__restoredMessages);
}
function y(e) {
	return s(e.__lastTurnStopped);
}
function b(e) {
	return s(e.__enableWebSearch);
}
function x(e) {
	let t = s(e.__approvalMode);
	return s(e.__approvalModeAvailable) ? t : "ask";
}
function S(e) {
	return {
		model: s(e.__model),
		isLocked: s(e.__modelLocked)
	};
}
//#endregion
export { x as useCopilotApprovalMode, h as useCopilotAvailableTools, y as useCopilotLastTurnStopped, m as useCopilotMessages, g as useCopilotMeta, S as useCopilotModel, _ as useCopilotQueuedMessages, v as useCopilotRestoredMessages, u as useCopilotSession, f as useCopilotSessionId, p as useCopilotStatus, b as useCopilotWebSearch, d as usePrimaryCopilotSession };
